"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramOf = void 0;
const react_1 = require("react");
const IS_1 = __importDefault(require("../../utils/IS"));
const react_router_dom_1 = require("react-router-dom");
const useParamState = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const { search } = (0, react_router_dom_1.useLocation)();
    const param = (0, react_1.useMemo)(() => (0, exports.paramOf)(search), [search]);
    const params = (0, react_1.useMemo)(() => new URLSearchParams(search), [search]);
    //? ---------------------- 👇 Utils ------------------------- //
    const toString = () => {
        return params.toString();
    };
    const get = (key) => {
        var _a;
        const value = (_a = params.get(key)) !== null && _a !== void 0 ? _a : undefined;
        if (value === null || value === void 0 ? void 0 : value.includes(','))
            return value.split(',');
        return value;
    };
    const set = (key, value) => {
        if (IS_1.default.array(value))
            value = value.join(',');
        params.set(key, value);
        history.replace({ search: params.toString() });
    };
    const setAll = (obj) => {
        for (const key in obj)
            set(key, obj[key]);
    };
    const remove = (key) => {
        params.delete(key);
        history.replace({ search: params.toString() });
    };
    const clear = () => {
        history.replace({ search: '' });
    };
    //----------------------------------------------------------------//
    return {
        set,
        get,
        clear,
        setAll,
        remove,
        toString,
        object: param === null || param === void 0 ? void 0 : param.object,
    };
};
const paramOf = (search) => {
    const param = { string: '', object: {} };
    //* String
    if (IS_1.default.string(search)) {
        param.string = search;
        const params = new URLSearchParams(search);
        const entries = Array.from(params.entries());
        for (const [key, value] of entries) {
            if (value === null || value === void 0 ? void 0 : value.includes(','))
                param.object[key] = value.split(',').map(x => (/^\d+$/.test(x) ? +x : x));
            else
                param.object[key] = value;
        }
    }
    //* Object
    if (IS_1.default.object(search)) {
        param.object = search;
        const params = [];
        const entries = Object.entries(search || {});
        for (const [key, value] of entries) {
            if (IS_1.default.array(value))
                params.push(`${key}=${value.join(',')}`);
            else
                params.push(`${key}=${value}`);
        }
        param.string = params.join('&');
    }
    return param;
};
exports.paramOf = paramOf;
exports.default = useParamState;
